<template>
  <div id="content" :style="'background-image: linear-gradient(to right, rgba(255,255,255,0.35), rgba(255,255,255,0.35)), url(\'' + gallery() +'\');'">
    
    <!-- If not Fullscreen show the default -->
    <div id="default">
 
      <div id="team-branding-wrapper">
 
        <div class="team-name-wrapper">
          <div class="team-name home">
            <span class="uppercase">Seymour High School Huskies</span>
          </div>
        </div>

        <div class="team-logo-wrapper">
          <div class="team-logo home">
             <img :src="GALLERY_HOST + '/' + zone2.val" :style="getImageStyle(zone2)">
          </div>
        </div>
 
      </div>

      <div id="scoreboard-wrapper">
        
        <!-- Top section holds the team name, score, period, possesion -->
        <div class="top score-data">

          <div class="left">
            <div class="team-name home"><span>{{zone3.val}}</span></div>
            <div class="score home"><span>22</span></div>
          </div>

          <div class="center time-division">
            <div class="heading uppercase"><span>Period</span></div>
            <div class="number-text"><span>3</span></div>
            <!-- **** 
                  Not sure how to toggle the possession arrow in real time. 
                  For now, click on the div to toggle the class 
                  for visual design purposes only!. 
            *** -->
            <div class="possession uppercase"><span>Possession</span></div>
          </div>

          <div class="right">
            <div class="team-name visitor"><span>{{zone4.val}}</span></div>
            <div class="score visitor"><span>20</span></div>
          </div>

        </div> <!-- END top score-data -->

        <!-- Middle section holds the timeouts, fouls, and bonus -->
        <div class="middle time-outs">
           <div class="left">
             <div class="timeout-wrapper">
               <div class="heading home uppercase"><span>Timeouts Left</span></div>
               <div class="number-text home"><span>5</span></div>
             </div>
             
             <div class="fouls-wrapper">
               <div class="bonus-wrapper">
                <div class="pill-bonus home uppercase">Bonus</div>
               </div>
               <div class="heading home uppercase"><span>Fouls</span></div>
               <div class="number-text home"><span>3</span></div>
             </div>
          </div>

          <div class="center">
          </div>

          <div class="right">
            <div class="timeout-wrapper">
              <div class="heading visitor uppercase"><span>Timeouts Left</span></div>
              <div class="number-text visitor"><span>1</span></div>
            </div>
            
            <div class="fouls-wrapper">
<!--              <div class="bonus-wrapper">
               <div class="pill-bonus visitor uppercase">Bonus</div>
             </div> -->
              <div class="heading home uppercase"><span>Fouls</span></div>
              <div class="number-text home"><span>6</span></div>
            </div>
          </div>
        </div>

        <!-- Bottom section holds the player stats, game clock, shot clock -->
        <div class="bottom stats">
 
          <div class="left player-stats home">
            <table>
              <thead class="uppercase">
                <th>Player</th>
                <th>Points</th>
                <th>Fouls</th>
              </thead>
              <!-- Loop for each player -->
              <tr>
                <td>23</td>
                <td>9</td>
                <td>0</td>
              </tr>
              <tr>
                <td>18</td>
                <td>8</td>
                <td>0</td>
              </tr>
              <tr>
                <td>34</td>
                <td>2</td>
                <td>0</td>
              </tr>
              <tr>
                <td>00</td>
                <td>1</td>
                <td>2</td>
              </tr>
              <tr>
                <td>45</td>
                <td>0</td>
                <td>1</td>
              </tr>
            </table>
          </div>

          <div class="center time-wrapper">
            <div id="game-clock">
              <div class="time"><span>03:24</span></div>
            </div>
            <div id="shot-clock">
              <div class="heading uppercase">Shot Clock</div>
              <div class="time">:<span>35</span></div>
            </div>
          </div>
 
          <div class="right player-stats visitor">
            <table>
              <thead class="uppercase">
                <th>Player</th>
                <th>Points</th>
                <th>Fouls</th>
              </thead>
              <!-- Loop for each player -->
              <tr>
                <td>22</td>
                <td>10</td>
                <td>1</td>
              </tr>
              <tr>
                <td>10</td>
                <td>8</td>
                <td>3</td>
              </tr>
              <tr>
                <td>15</td>
                <td>2</td>
                <td>2</td>
              </tr>
              <tr>
                <td>00</td>
                <td>1</td>
                <td>0</td>
              </tr>
              <tr>
                <td>45</td>
                <td>1</td>
                <td>0</td>
              </tr>
            </table>
          </div>

        </div>
 
      </div> <!-- END scoreboard-wrapper -->

      <!-- If not No Ads -->
      <div id="adverts_wrapper">
        <!--  do we need to get the index? -->
        <div class="left ad -1">
          <img :src="GALLERY_HOST + '/' + zone5.val" :style="getImageStyle(zone5)">
        </div>
        <div class="center ad -2">
          <img :src="GALLERY_HOST + '/' + zone6.val" :style="getImageStyle(zone6)">
        </div>
        <div class="right ad -3">
          <img :src="GALLERY_HOST + '/' + zone7.val" :style="getImageStyle(zone7)">
        </div>
      </div> <!-- END ads-wrapper -->
      
     </div> <!-- END default -->
  </div>
</template>

<script>
export default {
   data() {
      return {
         zone1: {}, //background image
         zone2: {}, //team logo
         zone3: {}, //home team
         zone4: {}, //away team
         zone5: {}, //left ad zone
         zone6: {}, //center ad zone
         zone7: {}  //right ad zone
      }
   },

   props: {
      json: {}
   },

   computed: {
      gallery() {
         return this.GALLERY_HOST + '/' + zone.val;
      }
   },

   created() {
      this.zone1 = this.json.tmpl.assets[0];
      this.zone2 = this.json.tmpl.assets[1];

      this.zone3 = this.json.tmpl.data.text[0];
      this.zone4 = this.json.tmpl.data.text[1];

      this.zone5 = this.json.tmpl.assets[2];
      this.zone6 = this.json.tmpl.assets[3];
      this.zone7 = this.json.tmpl.assets[4];
   },

   methods: {
      getImageStyle(zone) {
         return 'transform: scale(' + zone.scaleX + ', ' + zone.scaleY + '); left: ' + zone.assetX + 'px; top: ' + zone.assetY + 'px;';
      }
   }
}
</script>

<style lang="scss" scoped>
// vars
$width: 1920px;
$height: 1080px;

// background colors 
$darken: rgba(0,0,0,0.05); 
$black: rgba(0,0,0,1); 
$white: rgba(1,1,1,1);
$time-division: rgba(75, 165, 218,1);
$timeouts: rgba(28, 54, 92, 1);
$player-stats: rgba(34, 24, 19, 0.85);

// fonts
$red: rgb(223, 30, 36);
$darkgray: rgb(93,93,93);
$shot-clock: rgb(136,251,2);
@mixin team-name {
  font-size: 60px;
  font-weight: 700;
}

* {
  margin: 0 auto;
  padding: 0;
  border: 0;
	box-sizing: border-box;
}

body {
  width: $width;
  height: $height;
  overflow: hidden;
  text-align: center;
  background-color: $black;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #fff;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: initial;
}

.right {
  clear: right;
}
#content {
   transform: scale(.75);
   margin-top: -75px;
  width: $width;
  height: $height;
  padding-top: 20px;
  padding-bottom: 10px;
  text-align: left;
	overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
  background-size: 100% 100%;
}

// Team branding wrapper holds the team logo and team name 
#team-branding-wrapper {
  position: relative;
  width: 100%;
  height: 88px;
  
  .team-name-wrapper {
    text-align: center;
  
    .team-name {
      @include team-name;
      color: #fff;
    }
  }

  .team-logo-wrapper {
    position: absolute;
    top: -8px;
    left: 30px;
    background-color: transparent;
    z-index: 1;

    .team-logo {
       width: 250px;
       height: 250px;
       position: relative;
       overflow: hidden;

       img {
          max-width: 100%;
          max-height: 250px;
          position: absolute;
       }
    }
  }
}

// Scoreboard
#scoreboard-wrapper {
  position: relative;
  width: 1560px;
  height: 790px;
  text-align: center;
  
  > div {
    margin: 0 auto 1px auto;
  }
  
//  Top section holds the team name, score, period, possesion
  .top {
    &.score-data {
      width: 1560px;
      height: 315px;
      text-align: left;
      background-color: $black;
      color: #fff;
 
      > div {
        float: left;
        width: 520px; 
        height: 100%;
        text-align: center;
        background-color: $black;
      }
 
      .left, .right {
        .team-name {
          margin-top: 15px;
          @include team-name;
          color: inherit;
        }
        .score {
          height:  250px;
          margin-top: -80px;
          span {
            font-size: 246px;
            font-weight: 700;
            color: #4ba5da;}
        }
      }
      
      .time-division {
        position: relative;
        background-color: $time-division;
      
        .heading {
          margin-top: 15px;
          font-size: 43px;
        }

        .number-text {
          margin-top: -15px;
          font-size: 185px;
        }

        .possession {
          position: relative;
          margin-top: -15px;
          font-size: 30px;
        
          &:after {
            content: '';
            position: absolute;
            top: -2%;
            left: 70px;
            width: 62px;
            height: 44px;
            background:
              url('./img/possession-arrow.png')
              no-repeat
              left center 
              transparent;
            background-size: cover;
            transform-origin: left;
          }

          &.visitor:after {
            left: 450px;
            transform: rotate(180deg) ;
            
          }
        }
      }
    }
  }
  
//   Middle section holds the timeouts, fouls, and bonus
  .middle {
    &.time-outs {
      width: 1560px;
      height: 75px;
      background-color: $timeouts;
      color: #fff;

      > div {
        float: left;
        width: 520px; 
        height: 100%;
        padding: 10px 15px 0 15px;
        text-align: left;
        background-color: $timeouts;
      }
      
      .left, .right {
        > div, 
        > div > div {
          display: inline-block;
          vertical-align: middle;
        }
      }

      .timeout-wrapper {
        float: left;
      }
      .fouls-wrapper {
        float: right;

        .bonus-wrapper {
           display: none;
        }
      }

      .timeout-wrapper, .fouls-wrapper {
        .heading {
          font-size: 20px;
        }
      
        .number-text {
          padding: 0 11px;
          font-size: 40px;
          font-weight: 700;
        }
      }
      
      .bonus-wrapper {
        width: 100px;
        margin-left: 40px;
        .pill-bonus {
          display: inline-block;
          width: 80px;
          height: 26px;
          padding: 3px 0;
          text-align: center;
          border: none;
          border-radius: 8px;
          background-color: $red;
          box-shadow: 0px 1px 2px $darkgray;
        }
      }
    }
  }

// Bottom section holds the player stats, game clock, shot clock
  .bottom {
    width: 1560px;
    height: 390px;
    background-color: $player-stats;
    
    > div {
      float: left;
      width: 520px; 
      height: 100%;
      text-align: left;
    }
    
    .player-stats {
      padding: 20px 0 10px 0;
      background-color: transparent;
      
      table {
        width: 100%;
        height: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
        overflow: hidden;
        text-align: center;
        
        thead {
          background-color: $black;
        }
 
        tr:not(:last-of-type) {
          border-bottom: 1px solid white;
        }
 
        thead > tr {
          border-bottom: 0;
        }
  
        th {
          height: 24px;
          font-size: 16px;
        }
 
        td {
          vertical-align: baseline;
          line-height: 65px;
          font-size: 36px;
          color: white;
          text-align: center;
        }
      }
    }
    .time-wrapper {
      padding-top: 50px;
      position: relative;
      background-color: $time-division;
      background-image: url('./img/time-background.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      
      #game-clock {
        text-align: center;
        font-weight: 700;
        font-size: 184px;
        color: white;
      }
      
      #shot-clock {
        width: 180px;
        padding-top: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $timeouts;
        text-align: center;
        color: $shot-clock;
        
        .heading {
          font-weight: 700;
          font-size: 14px;
        }
        .time {
          font-weight: 700;
          font-size: 48px;
        }
      }
    }
  }
}
// END scoreboard-wrapper

// Ads section holds, well, ads
#adverts_wrapper {
  width: 1560px;
  height: 160px;
  text-align: center;
  background-color: $black;
  display: flex;
  justify-content: space-between;
  
  > div {
      width: 498px; 
      height: 130px;
      top: 15px;
      left: 10px;
      overflow: hidden;
      position: relative;

      img {
         position: absolute;
      }
  }
}
</style>